import { render } from "./SettingsOrganization.vue?vue&type=template&id=4132f2fe&scoped=true&ts=true"
import script from "./SettingsOrganization.vue?vue&type=script&lang=ts"
export * from "./SettingsOrganization.vue?vue&type=script&lang=ts"

import "./SettingsOrganization.vue?vue&type=style&index=0&id=4132f2fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4132f2fe"]])

export default __exports__